export enum PromoAvailableTypeEnum {
    None = 0,
    AllCustomers = 1,
    NewCustomers = 2,
    ReturningCustomers = 3,
    CustomUsers = 4
}
